import { createApi } from '@stilingue/st-auth-utils';
import Service from './Service';
import { error401Handler } from '@/utils/error';

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = (response) => {
  return response.data;
};

class TotalCallsService extends Service {
  constructor(gateway) {
    const api = createApi('/total-calls', gateway, {
      authNotFound: () => true,
      error401Handler,
    });

    super(api, {
      afterParser,
      retriesLimit: 10,
    });

    this.api.http.defaults.timeout = 600000;
  }

  getIncomingAttended(params) {
    return this.find({
      ...params,
      url: '/incoming-attended/daily',
    });
  }
}

export default new TotalCallsService(gateway);
